(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InvoicePatientDetailController', InvoicePatientDetailController);

    InvoicePatientDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InvoicePatient', 'Invoice'];

    function InvoicePatientDetailController($scope, $rootScope, $stateParams, previousState, entity, InvoicePatient, Invoice) {
        var vm = this;

        vm.invoicePatient = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:invoicePatientUpdate', function(event, result) {
            vm.invoicePatient = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
